import Grid from '@material-ui/core/Grid';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
export const StyledLabel = styled.p`
  font-size: 13px;
  font-family: 'OpenSans-Regular' !important;
  color: #141414;
  margin: 10px;
`;
export const StyledGrid = styled(Grid)`
  && {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 18%;
    padding-left: 24%;
  }
`;
export const StyledCardBody = styled.div`
  border: 1px solid #c9d3dc;
  width: 100%;
  padding: 10px;
  margin-left: 1%;
  border-radius: 4px;
  min-height: 58px;
  overflow: auto;
`;
export const StyledChip = styled(Chip)`
  && {
    margin: 2px;
  }
`;
export const StyledCustomLinkButton = styled(Button)`
  &.MuiButton-root {
    margin-right: 5px;
    min-width: 101px;
    height: 32px !important;
    color: #005099 !important;
    font-size: 13px !important;
    font-family: 'OpenSans-Light' !important;
    border-radius: 4px;
    border: 1px solid #005099 !important;
    background-color: white !important;
    text-transform: none !important;
  }
  &.Mui-disabled {
    opacity: 0.65;
  }
`;
export const StyledLinkButton = styled(Button)`
  &.MuiButton-root {
    margin: 0px 5px;
    font-size: 13px !important;
    line-height: 15px !important;
    color: #005099 !important;
    font-family: 'OpenSans-Light';
    font-weight: 400;
    text-transform: none !important;
    min-width: 80px;
  }
  &.Mui-disabled {
    opacity: 0.65;
  }
  &.MuiButton-root:hover {
    background: none;
  }
`;
export const StyledLabelGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 175px;
`;
export const StyledBody = styled(Grid)`
  border-bottom: 1px solid #c9d3dc;
  padding-bottom: 25px;

  &.MuiGrid-container {
    flex-wrap: nowrap;
  }
`;
export const StyledTextGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 59%;
  max-width: 874px;
`;